import React, { useState } from "react";
import { get } from "lodash";
import CarouselComponent from "@/components/CarouselComponent";

import "./index.less";
import BaseInput from "../BaseInput";

// 行开放题
export default function MatrixInput({ info, answer, changeAnswer }) {
  let {
    id,
    childs,
    preferences: { childPrefer = {}, optionPrefer = {} },
  } = info;
  const [carouseFn, setcarouseFn] = useState(null);

  const onChangeAnswer = (subId, newAnswer) => {
    changeAnswer({
      ...get(answer, `[${id}]`, {}),
      [subId]: newAnswer,
    });
  };

  const InptutTotal =(_id)=>{
    const lastLayerObjects = {};
    getLastLayerObjects(answer, lastLayerObjects);

    let result = Object.values(lastLayerObjects).reduce((acc, value) => acc + Number(value), 0);

    return result+ info?.preferences?.optionPrefer?.optionUnit
  }

  
  const getLastLayerObjects = (obj, result = {}) => {
    Object.entries(obj).forEach(([key, value]) => {
      console.log("valuevalue",value);
      if (value&&typeof value === 'object' && !Array.isArray(value)) {
         if(value?.text){
          result[key] = value.text;
         }else{
          getLastLayerObjects(value, result);

         }
      } else {
        result[key] = value;
        //result.push({ [key]: value });
      }
    });
  };

   return (
    <div className="matrix-input">
      <div className="q-matrix-content">
        <CarouselComponent
          colData={childs}
          info={info}
          callback={(dom, autoplayFn, current) => {
            setcarouseFn({ ...dom, autoplayFn, current });
          }}
        >
          {(childs || []).map((child, index) => {

             if (+child.moduleOption > 0) {
              if (+child.moduleOption === 2) {
                return null;
              } else {
                return (
                  <div className="q-item q-item-module" key={child.id}>
                    <div
                      className="q-item-title q-item-title-module"
                      dangerouslySetInnerHTML={{
                        __html: child.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>
                );
              }
            }
            return (
              <div className="q-item" key={child.id}>
                <div
                  id={child.id}
                  className="q-item-title"
                  dangerouslySetInnerHTML={{
                    __html: child.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />
                <div className="q-item-content">
                  {child.data_total? <>
                  {InptutTotal()}
                  
                  </>: <BaseInput
                    info={{ ...child, optionPrefer }}
                    info2={{...info}}
                    answer={get(answer, `[${id}]`)}
                    changeAnswer={(newAnswer) => {
                      onChangeAnswer(child.id, newAnswer);
                    }}
                  />
                  }
                 
                </div>
               
              </div>
            );
          })}
        </CarouselComponent>
      </div>
    </div>
  );
}
